import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import cam from "../Assets/camera-svgrepo-com (2) 2.png";
import Footer from "../Components/Footer";
import { toast } from "react-toastify";
import { apiPut, Get_Api } from "../ApiUrls";
import { useNavigate } from "react-router-dom";

function AboutForm() {
  const navigate = useNavigate();
  const [IsUploading, setIsUploading] = useState(false);
  const [AllAvailable, setAllAvailable] = useState([]);
  const [AllHobby, setAllHobby] = useState([]);
  const [AvailableFor, setAvailableFor] = useState([]);
  const [PersonalityorHobbies, setPersonalityorHobbies] = useState([]);
  const [Country, setCountry] = useState('');
  const [State, setState] = useState('');
  const [City, setCity] = useState('');
  const [AboutMe, setAboutMe] = useState('');

  const [cities, setCities] = useState([]);

  const GetAvailableFor = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllAvailableFor`);
      setAllAvailable(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  // const GetallHobby = async () => {
  //   try {
  //     setIsUploading(true);
  //     const response = await Get_Api(`api/admin/GetAllHobby`);
  //     setAllHobby(response?.data);
  //     setIsUploading(false);
  //   } catch (error) {
  //     setIsUploading(false);
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    GetAvailableFor();
    // GetallHobby();
  }, []);

  const handleSelection = (name, type) => {
    if (type === "AvailableFor") {
      setAvailableFor((prev) =>
        prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
      );
    } else if (type === "Hobby") {
      setPersonalityorHobbies((prev) =>
        prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
      );
    }
  };


  const UpdateHostess = async () => {
    if (!Country) {
      toast.error("Country is required!");
      return;
    }
    if (!State) {
      toast.error("State is required!");
      return;
    }
    if (!City) {
      toast.error("City is required!");
      return;
    }
    if (!AboutMe) {
      toast.error("AboutMe is required!");
      return;
    }
    if (AvailableFor.length === 0) {
      toast.error("AvailableFor is required!");
      return;
    }
    try {
      let data = { Country, State, City, AvailableFor, AboutMe };
      setIsUploading(true);
      const response = await apiPut(`api/hostess/UpdateHostess`, data);
      localStorage.setItem('Country', Country || "India");
      toast.success(response?.message);
      navigate('/addphotos')
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      toast.error(error?.response?.data?.message);
      console.log(error);
    }
  };


  const [AllCountry, setAllCountry] = useState([]);


  const GetAllCountries = async () => {
    try {
      const response = await Get_Api('api/admin/GetAllCountry');
      setAllCountry(response?.data || []);
    } catch (error) {
      alert(error?.response?.data?.message || 'Failed to fetch countries.');
    }
  };

  const [allStateCity, setAllStateCity] = useState([]);

  const getAllStateCity = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllStateCity?country=${Country}`);
      setAllStateCity(response.data || []);
      setIsUploading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    GetAllCountries();
  }, []);

  useEffect(() => {
    getAllStateCity();
  }, [Country]);

  const handleStateChange = (e) => {
    const StateTitle = e.target.value;
    setState(StateTitle);

    const stateObj = allStateCity?.find((state) => state.Title === StateTitle);

    if (stateObj) {
      setCities(stateObj.City || []);
    } else {
      setCities([]);
    }
  };



  return (
    <>
      <Navbar />
      <div className="login-div">
        <div className="login-div-form">
          <h4>
            Welcome to <span>Hostess</span>
          </h4>
          <h3>About You</h3>
          <br />
          <div className="about-input-div">
            <div className="about-input">
              <label>Country</label>
              <select
                value={Country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option value="" disabled>Select Country</option>
                {AllCountry.map((country, index) => (
                  <option key={index} value={country?.Title}>
                    {country?.Title}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <br />
          <div className="about-input-div">
            <div className="about-input">
              <label>State</label>
              <select
                value={State}
                onChange={handleStateChange}
                disabled={!Country}
              >
                <option value="" disabled>Select State</option>
                {allStateCity?.map((State, index) => (
                  <option key={index} value={State?.Title}>
                    {State?.Title}
                  </option>
                ))}
              </select>
            </div>
            <div className="about-input">
              <label>City</label>
              <select
                value={City}
                onChange={(e) => setCity(e.target.value)}
                disabled={!State}
              >
                <option value="" disabled>Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <br />
          <div className="about-input-div">
            <div className="about-input">
              <label>About Me</label>
              <input
                placeholder="About Me"
                value={AboutMe}
                onChange={(e) => setAboutMe(e.target.value)}
              />
            </div>
          </div>
          <br />
          <div className="AvailableFor">
            <h3>Available For</h3>
            <br />
            <div className="ModelPhoto-div">
              {AllAvailable.map((item) => (
                <div
                  className={`ModelPhoto ${AvailableFor.includes(item.Name) ? 'selected' : ''}`}
                  key={item._id}
                  onClick={() => handleSelection(item.Name, "AvailableFor")}
                >
                  <img src={item.Image} alt={item.Name} />
                  <h3>{item.Name}</h3>
                </div>
              ))}
            </div>
          </div>
          <br />
          {/* <div className="AvailableFor">
            <h3>Personalities & Hobbies</h3>
            <br />
            <div className="ModelPhoto-div">
              {AllHobby.map((item) => (
                <div
                  className={`ModelPhoto ${PersonalityorHobbies.includes(item.Name) ? 'selected' : ''}`}
                  key={item._id}
                  onClick={() => handleSelection(item.Name, "Hobby")}
                >
                  <h3>{item.Name}</h3>
                </div>
              ))}
            </div>
          </div> */}
          <br />
          <br />
          <button onClick={UpdateHostess} className="abyou">
            {IsUploading ? 'Uploading...' : 'Next'}
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AboutForm;